import { Component, inject } from '@angular/core';
import { MonthService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  MonthCreateDto,
  MonthDto,
  MonthExcelDownloadDto,
  MonthUpdateDto,
} from '../proxy/general/dtos/month';
import { MONTH_CONFIG, MONTH_FIELDS } from './month.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-month',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, MonthService, ConfirmationService],
  templateUrl: './month.html',
  styleUrl: './month.scss',
})
export class Month extends BaseCrudComponent<
  MonthDto,
  MonthCreateDto,
  MonthUpdateDto,
  MonthExcelDownloadDto
> {
  service = inject(MonthService);
  config = MONTH_CONFIG;
  fields = MONTH_FIELDS;

  protected prepareUpdateDto(data: any, selected: MonthDto): MonthUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Month';
  }
}
